<!--
 * @Author: 陈乾
 * @Date: 2025-09-19 10:02:09
 * @LastEditors: 陈乾
 * @LastEditTime: 2025-09-19 15:01:21
 * @Description: file content
 * @FilePath: /Cheers 上线速览/src/components/table.vue
-->
<template>
  <div class="base-table">
    <table>
      <thead ref="thead">
        <tr>
          <th
            v-for="col in columns"
            :key="col.key"
            :style="{ width: col.width || 'auto', textAlign: col.align || 'left' }"
          >
            {{ col.name }}
          </th>
        </tr>
      </thead>
      <tbody v-if="list.length > 0">
        <tr v-for="(row, rowIndex) in list" :key="rowIndex" ref="tr">
          <td v-for="col in columns" :key="col.key" :style="{ textAlign: col.align || 'left' }">
            <!-- ✅ 插槽优先，没定义就显示默认值 -->
            <slot :name="col.key" :row="row">
              {{ row[col.key] }}
            </slot>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-if="list.length === 0" class="flex-x-y noData font15">暂无数据</p>
  </div>
</template>

<script>
export default {
  name: 'BaseTable',
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    list: {
      immediate: true,
      deep: true,
      handler(val) {
        console.log(val, 999999)
        if (val.length > 0) {
          this.$nextTick(() => {
            this.$emit('getTableHeight', {
              minHeight:
                this.$refs.tr
                  .slice(0, 3)
                  .map(item => item.clientHeight)
                  .reduce((total, num) => total + num, 0) +
                this.$refs.thead.clientHeight +
                1 +
                'px',
              maxHeight:
                this.$refs.tr.map(item => item.clientHeight).reduce((total, num) => total + num, 0) +
                this.$refs.thead.clientHeight +
                1 +
                'px'
            })
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.base-table table {
  width: 100%;
  border-collapse: collapse;
}

.base-table th {
  padding: 8px 12px;
  border-bottom: 1px solid #eaeaea; /* ✅ 只要下边框 */
  color: #676870;
  font-size: 15px;
  white-space: nowrap;
}

.base-table td {
  padding: 16px 12px;
  border-bottom: 1px solid #eaeaea; /* ✅ 只要下边框 */
  font-size: 15px;
}

.base-table th {
  font-weight: 400;
}
.base-table .noData {
  width: 100%;
  padding: 16px 0;
}
</style>
